/* eslint-disable */
export default {
  close: 'Schließen',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
